import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EditActorModalProps, EDIT_ACTOR_MODAL } from '../../components/modals/EditActorModal'
import { EditAssignmentModalProps, EDIT_ASSIGNMENT_MODAL } from '../../components/modals/EditAssignmentModal'
import { ExportErtTimestampsProps, EXPORT_ERT_TIMESTAMPS_MODAL } from '../../components/modals/ExportErtTimestamps'
import { ImportModalProps, IMPORT_MODAL } from '../../components/modals/ImportModal'

type ModalsSliceState = {
    openModals: {
        type: string
        options: any
    }[]
}

const initialState: ModalsSliceState = {
    openModals: []
}

const slice = createSlice({
    name: 'modals',
    initialState,
    reducers: {

        popModal: (state) => {
            state.openModals.pop()
        },

        openEditActorModal: (state, { payload }: PayloadAction<EditActorModalProps>) => {
            state.openModals.push({
                type: EDIT_ACTOR_MODAL,
                options: payload
            })
        },

        openEditAssignmentModal: (state, { payload }: PayloadAction<EditAssignmentModalProps>) => {
            state.openModals.push({
                type: EDIT_ASSIGNMENT_MODAL,
                options: payload
            })
        },

        openImportModal: (state, { payload }: PayloadAction<ImportModalProps>) => {
            state.openModals.push({
                type: IMPORT_MODAL,
                options: payload
            })
        },

        openExportTimestampsModal: (state, { payload }: PayloadAction<ExportErtTimestampsProps>) => {
            state.openModals.push({
                type: EXPORT_ERT_TIMESTAMPS_MODAL,
                options: payload
            })
        },

    }

})

export const modalsReducer = slice.reducer
export const ModalsActions = slice.actions